import React, { Component } from "react";
import "./Editmedicine.css";
import axiosInstance from "../../api/axiosInstance";
import Cookies from "js-cookie";
import moment from "moment";
import {
  HiOutlineX,
  HiOutlineCalendar,
  HiOutlineCurrencyRupee,
  HiOutlineCurrencyDollar,
  HiOutlineCube,
  HiOutlineClock,
  HiOutlineCheckCircle,
  HiOutlineBan,
  HiOutlineExclamationCircle,
} from "react-icons/hi";
import { notification } from "antd";

class EditMedicineModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        id: "",
        medicine_name: "",
        dosage: "",
        stock: "",
        per_stock_price: "",
        per_tablet_price: "",
        manufacturingDate: "",
        expireDate: "",
        status: "A",
        lastModifiedDate: "",
      },
      loading: false,
    };
  }

  componentDidMount() {
    this.loadMedicineData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.medicineID !== this.props.medicineID || prevProps.data !== this.props.data) {
      this.loadMedicineData();
    }
  }

  formatDateForInput = (dateVal) => {
    if (!dateVal) return "";
    const m = moment(dateVal);
    return m.isValid() ? m.format("YYYY-MM-DD") : "";
  };

  loadMedicineData = () => {
    const { data, medicineID } = this.props;
    if (data && medicineID) {
      const selectedMedicine = data.find(
        (item) => String(item.id) === String(medicineID) || String(item.Medicine_ID) === String(medicineID)
      );
      if (selectedMedicine) {
        this.setState({
          formData: {
            id: selectedMedicine.id || selectedMedicine.Medicine_ID || "",
            medicine_name: selectedMedicine.medicine_name || selectedMedicine.Medicine_Name || "",
            dosage: selectedMedicine.dosage || "",
            stock: selectedMedicine.stock !== undefined ? selectedMedicine.stock : (selectedMedicine.Unit || ""),
            per_stock_price: selectedMedicine.per_stock_price !== undefined ? selectedMedicine.per_stock_price : (selectedMedicine.Price || ""),
            per_tablet_price: selectedMedicine.per_tablet_price !== undefined ? selectedMedicine.per_tablet_price : (selectedMedicine.Qty || ""),
            manufacturingDate: this.formatDateForInput(selectedMedicine.mfg_date || selectedMedicine.MFG_Date),
            expireDate: this.formatDateForInput(selectedMedicine.exp_date || selectedMedicine.EXP_Date),
            status: selectedMedicine.sales_admin_sts || (selectedMedicine.Status === "Inactive" ? "I" : "A"),
            lastModifiedDate: selectedMedicine.modified_on
              ? moment(selectedMedicine.modified_on).format("YYYY-MM-DD")
              : (selectedMedicine.created_on ? moment(selectedMedicine.created_on).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")),
          },
        });
      }
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => {
      const newFormData = {
        ...prevState.formData,
        [name]: value,
      };

      // Auto-compute per tablet price if stock and per_stock_price are entered and per_tablet_price is not manually changed
      if ((name === "per_stock_price" || name === "stock") && Number(newFormData.stock) > 0 && Number(newFormData.per_stock_price) > 0) {
        const stockNum = Number(newFormData.stock);
        const priceNum = Number(newFormData.per_stock_price);
        if (stockNum > 0 && !prevState.formData.userCustomTabletPrice) {
          newFormData.per_tablet_price = (priceNum / stockNum).toFixed(2);
        }
      }

      if (name === "per_tablet_price") {
        newFormData.userCustomTabletPrice = true;
      }

      return { formData: newFormData };
    });
  };

  handleStatusChange = (newStatus) => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        status: newStatus,
      },
    }));
  };

  handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const { formData } = this.state;
    const { handleopenSuccess, onClose } = this.props;

    if (!formData.medicine_name.trim()) {
      notification.warning({ message: "Please enter Medicine Name" });
      return;
    }
    if (formData.stock === "" || formData.stock === null || formData.stock === undefined) {
      notification.warning({ message: "Please enter Stock quantity" });
      return;
    }
    if (formData.per_stock_price === "" || formData.per_stock_price === null || formData.per_stock_price === undefined) {
      notification.warning({ message: "Please enter Per Stock Price" });
      return;
    }

    this.setState({ loading: true });

    try {
      const pharmacyId = Cookies.get("pharmacy_id") || localStorage.getItem("pharmacy_id") || 0;
      const modifiedBy = Cookies.get("vendor_id") || Cookies.get("user_id") || 0;

      const payload = {
        id: formData.id,
        medicine_name: formData.medicine_name.trim(),
        stock: Number(formData.stock) || 0,
        per_stock_price: Number(formData.per_stock_price) || 0,
        per_tablet_price: Number(formData.per_tablet_price) || 0,
        mfg_date: formData.manufacturingDate || null,
        exp_date: formData.expireDate || null,
        sales_admin_sts: formData.status,
        status: formData.status,
        pharmacy_id: pharmacyId,
        modified_by: modifiedBy,
      };

      const response = await axiosInstance.post("pharmacy/edit_mas_pharm_medicine_rate", payload);

      if (
        response &&
        response.data &&
        (response.data.status === 1 ||
          response.data.ErrorCode === "9999" ||
          response.data.data?.[0]?.ErrorCode === "9999" ||
          response.data.msg === "Success" ||
          response.data.msg === "Medicine updated successfully")
      ) {
        if (handleopenSuccess) {
          handleopenSuccess("Medicine updated successfully.", true);
        } else {
          notification.success({ message: "Medicine updated successfully" });
        }
        if (onClose) onClose();
      } else {
        const errorMsg = response?.data?.msg || "Failed to update medicine";
        if (handleopenSuccess) {
          handleopenSuccess(errorMsg, false);
        } else {
          notification.error({ message: errorMsg });
        }
      }
    } catch (err) {
      console.error("Failed to update medicine:", err);
      notification.error({
        message: err?.response?.data?.msg || "An error occurred while updating medicine.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { editModalOpen, onClose } = this.props;
    const { formData, loading } = this.state;

    if (!editModalOpen) return null;

    return (
      <div className="edit-med-backdrop" onClick={onClose}>
        <div className="edit-med-modal" onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <div className="edit-med-header">
            <div className="edit-med-header-left">
              <div className="edit-med-icon-badge">
                💊
              </div>
              <div>
                <h3 className="edit-med-title">Edit Medicine</h3>
                <p className="edit-med-subtitle">Update medicine inventory details and pricing</p>
              </div>
            </div>
            <div className="edit-med-header-right">
              {formData.id && (
                <span className="edit-med-id-pill">ID: #{formData.id}</span>
              )}
              <button
                type="button"
                className="edit-med-close-btn"
                onClick={onClose}
                aria-label="Close"
              >
                <HiOutlineX />
              </button>
            </div>
          </div>

          {/* Body Form */}
          <div className="edit-med-body">
            <form onSubmit={this.handleSubmit} className="edit-med-grid">
              {/* Medicine Name */}
              <div className="edit-med-field edit-med-col-span-2">
                <label className="edit-med-label">
                  Medicine Name <span className="edit-med-required">*</span>
                </label>
                <div className="edit-med-input-wrapper">
                  <span className="edit-med-input-icon">💊</span>
                  <input
                    name="medicine_name"
                    type="text"
                    placeholder="e.g. Paracetamol 500mg"
                    className="edit-med-input"
                    value={formData.medicine_name}
                    onChange={this.handleInputChange}
                    required
                  />
                </div>
              </div>

              {/* Status Selector */}
              <div className="edit-med-field edit-med-col-span-2">
                <label className="edit-med-label">
                  Status <span className="edit-med-required">*</span>
                </label>
                <div className="edit-med-status-group">
                  <button
                    type="button"
                    className={`edit-med-status-btn ${formData.status === "A" ? "active-sts" : ""}`}
                    onClick={() => this.handleStatusChange("A")}
                  >
                    <HiOutlineCheckCircle size={17} />
                    Active
                  </button>
                  <button
                    type="button"
                    className={`edit-med-status-btn ${formData.status === "P" ? "pending-sts" : ""}`}
                    onClick={() => this.handleStatusChange("P")}
                  >
                    <HiOutlineExclamationCircle size={17} />
                    Pending
                  </button>
                  <button
                    type="button"
                    className={`edit-med-status-btn ${formData.status === "I" ? "inactive-sts" : ""}`}
                    onClick={() => this.handleStatusChange("I")}
                  >
                    <HiOutlineBan size={17} />
                    Inactive
                  </button>
                </div>
              </div>

              {/* Stock */}
              <div className="edit-med-field">
                <label className="edit-med-label">
                  Stock Units <span className="edit-med-required">*</span>
                </label>
                <div className="edit-med-input-wrapper">
                  <HiOutlineCube className="edit-med-input-icon" />
                  <input
                    name="stock"
                    type="number"
                    min="0"
                    placeholder="e.g. 100"
                    className="edit-med-input"
                    value={formData.stock}
                    onChange={this.handleInputChange}
                    required
                  />
                </div>
              </div>

              {/* Per Stock Price */}
              <div className="edit-med-field">
                <label className="edit-med-label">
                  Per Stock Price ({"₹"}) <span className="edit-med-required">*</span>
                </label>
                <div className="edit-med-input-wrapper">
                  <span className="edit-med-input-icon">
                    <HiOutlineCurrencyDollar size={18} />
                  </span>
                  <input
                    type="number"
                    step="0.001"
                    name="per_stock_price"
                    value={formData.per_stock_price}
                    onChange={this.handleInputChange}
                    placeholder="0.000"
                    className="edit-med-input"
                  />
                </div>
              </div>

              {/* Per Tablet Price */}
              <div className="edit-med-field">
                <label className="edit-med-label">
                  Per Tablet Price ({"₹"})
                </label>
                <div className="edit-med-input-wrapper">
                  <HiOutlineCurrencyRupee className="edit-med-input-icon" />
                  <input
                    name="per_tablet_price"
                    type="number"
                    step="0.01"
                    min="0"
                    placeholder="e.g. 1.20"
                    className="edit-med-input"
                    value={formData.per_tablet_price}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>

              {/* Manufacture Date */}
              <div className="edit-med-field">
                <label className="edit-med-label">
                  Manufacture Date
                </label>
                <div className="edit-med-input-wrapper">
                  <HiOutlineCalendar className="edit-med-input-icon" />
                  <input
                    name="manufacturingDate"
                    type="date"
                    className="edit-med-input"
                    value={formData.manufacturingDate}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>

              {/* Expire Date */}
              <div className="edit-med-field">
                <label className="edit-med-label">
                  Expiry Date
                </label>
                <div className="edit-med-input-wrapper">
                  <HiOutlineCalendar className="edit-med-input-icon" />
                  <input
                    name="expireDate"
                    type="date"
                    className="edit-med-input"
                    value={formData.expireDate}
                    onChange={this.handleInputChange}
                  />
                </div>
              </div>
            </form>
          </div>

          {/* Footer */}
          <div className="edit-med-footer">
            <div className="edit-med-last-update">
              <HiOutlineClock size={16} />
              <span>Last Modified: {formData.lastModifiedDate || "N/A"}</span>
            </div>
            <div className="edit-med-actions">
              <button
                type="button"
                className="edit-med-cancel-btn"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="edit-med-submit-btn"
                onClick={this.handleSubmit}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="edit-med-spinner"></span>
                    <span>Updating...</span>
                  </>
                ) : (
                  <span>Update Medicine</span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditMedicineModal;

